import StatsByTariff from './StatsByTariff';

export default StatsByTariff;
